export const MOBILE_SCREEN_MAX_WIDTH = 768;
